import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    inputBeds: false,
    inputBaths: false,
    inputCars: false,
    inputLotSizeRange: [0, 10000],
    inputDwellingSizeRange: [0, 10000],
    inputPriceRange: [0, 10000],
    inputLotNumber: '',
    inputBuilder: '',
    inputColourScheme: '',
    inputHouseDesign: '',
  },

  mutations: {
    SET_FILTER_PARAMETERS: (state, parameters) => {
      if (!_.isUndefined(parameters.inputBeds)) state.inputBeds = parameters.inputBeds
      if (!_.isUndefined(parameters.inputBaths)) state.inputBaths = parameters.inputBaths
      if (!_.isUndefined(parameters.inputCars)) state.inputCars = parameters.inputCars
      if (!_.isUndefined(parameters.inputLotSizeRange)) state.inputLotSizeRange = parameters.inputLotSizeRange
      if (!_.isUndefined(parameters.inputDwellingSizeRange)) state.inputDwellingSizeRange = parameters.inputDwellingSizeRange
      if (!_.isUndefined(parameters.inputPriceRange)) state.inputPriceRange = parameters.inputPriceRange
      if (!_.isUndefined(parameters.inputLotNumber)) state.inputLotNumber = parameters.inputLotNumber
      if (!_.isUndefined(parameters.inputBuilder)) state.inputBuilder = parameters.inputBuilder
      if (!_.isUndefined(parameters.inputColourScheme)) state.inputColourScheme = parameters.inputColourScheme
      if (!_.isUndefined(parameters.inputHouseDesign)) state.inputHouseDesign = parameters.inputHouseDesign
    },    

    RESET_FILTER_PARAMETERS: (state) => {
      state.inputBeds = false
      state.inputBaths = false
      state.inputCars = false
      state.inputLotSizeRange = [0, 10000]
      state.inputDwellingSizeRange = [0, 10000]
      state.inputPriceRange = [0, 10000]
      state.inputLotNumber = ''
      state.inputBuilder = ''
      state.inputColourScheme = ''
      state.inputHouseDesign = ''
    },
  },

  getters: {
    priceRanges: (state, getters, rootState, rootGetters) => {
      const pathway = rootState.route.name === 'packages' ? 'packages' : rootState.route.params.pathway
      let priceRanges = []

      // packages price ranges
      if (['packages', 'package-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsPackages'].length) {
        const minVal = _.minBy(rootGetters['property/livingOptionsPackages'], 'price').price / 1000
        const maxVal = _.maxBy(rootGetters['property/livingOptionsPackages'], 'price').price / 1000
        priceRanges.push(Math.floor(minVal / 50) * 50)
        priceRanges.push(Math.ceil(maxVal / 50) * 50)

        return priceRanges
      } 
      
      // dwellings price ranges
      if (['dwellings', 'dwelling-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsDwellings'].length) {
        let priceMinVal = _.minBy(rootGetters['property/livingOptionsDwellings'], 'price')
        let priceMaxVal = _.maxBy(rootGetters['property/livingOptionsDwellings'], 'price')

        if (priceMinVal) {
          priceMinVal = priceMinVal.price / 1000
          priceRanges.push(Math.floor(priceMinVal / 50) * 50)
        }

        if (priceMaxVal) {
          priceMaxVal = priceMaxVal.price / 1000
          priceRanges.push(Math.ceil(priceMaxVal / 50) * 50)
        }

        return priceRanges
      }

      if (['apartments', 'townhouses', 'houses'].includes(pathway)) {
        let min = rootGetters['property/activeLivingOption'].filter.dwellingPriceRange[0] / 1000
        let max = rootGetters['property/activeLivingOption'].filter.dwellingPriceRange[1] / 1000
        min = Math.floor(min / 50) * 50
        max = Math.ceil(max / 50) * 50

        return [min, max]
      }

      if (['land'].includes(pathway)) {
        if (rootGetters['property/activeLivingOption']) {
          let min = rootGetters['property/activeLivingOption'].filter.landPriceRange[0] / 1000
          let max = rootGetters['property/activeLivingOption'].filter.landPriceRange[1] / 1000
          min = Math.floor(min / 50) * 50
          max = Math.ceil(max / 50) * 50
  
          return [min, max]
        }
      }

      return priceRanges
    },

    lotSizeRanges: (state, getters, rootState, rootGetters) => {
      const pathway = rootState.route.name === 'packages' ? 'packages' : rootState.route.params.pathway
      let lotSizeRanges = []

      if (['packages', 'package-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsPackages'].length) {
        const minVal = _.minBy(rootGetters['property/livingOptionsPackages'], 'property.size').property.size
        const maxVal = _.maxBy(rootGetters['property/livingOptionsPackages'], 'property.size').property.size
        lotSizeRanges.push(Math.floor(minVal / 25) * 25)
        lotSizeRanges.push(Math.ceil(maxVal / 25) * 25)

        return lotSizeRanges
      } 
      
      if (['dwellings', 'dwelling-modal'].includes(rootState.route.name) && getters.dwellings.length) {
        let sizeMinVal = _.minBy(rootGetters['property/livingOptionsDwellings'], 'size')
        let sizeMaxVal = _.maxBy(rootGetters['property/livingOptionsDwellings'], 'size')

        if (sizeMinVal) {
          sizeMinVal = sizeMinVal.size
          lotSizeRanges.push(Math.floor(sizeMinVal / 25) * 25)
        }

        if (sizeMaxVal) {
          sizeMaxVal = sizeMaxVal.size
          lotSizeRanges.push(Math.ceil(sizeMaxVal / 25) * 25)
        }

        return lotSizeRanges
      } 

      if (['apartments', 'townhouses', 'land', 'houses'].includes(pathway) && rootGetters['property/activeLivingOption']) {
        let min = rootGetters['property/activeLivingOption'].filter.sizeRange[0]
        let max = rootGetters['property/activeLivingOption'].filter.sizeRange[1]
        min = Math.floor(min / 25) * 25
        max = Math.ceil(max / 25) * 25

        return [min, max]
      }
    },

    dwellingSizeRanges: (state, getters, rootState, rootGetters) => {
      const pathway = rootState.route.name === 'packages' ? 'packages' : rootState.route.params.pathway
      let sizeRange = []

      if (['packages', 'package-modal'].includes(rootState.route.name) && rootGetters['property/livingOptionsPackages'].length) {
        const minVal = _.minBy(rootGetters['property/livingOptionsPackages'], 'dwelling.size').dwelling.size
        const maxVal = _.maxBy(rootGetters['property/livingOptionsPackages'], 'dwelling.size').dwelling.size
        sizeRange.push(Math.floor(minVal / 25) * 25)
        sizeRange.push(Math.ceil(maxVal / 25) * 25)

        return sizeRange
      }
      
      if (['dwellings', 'dwelling-modal'].includes(rootState.route.name) && rootGetters['property/dwellings'].length) {
        let sizeMinVal = _.minBy(rootGetters['property/livingOptionsDwellings'], 'size')
        let sizeMaxVal = _.maxBy(rootGetters['property/livingOptionsDwellings'], 'size')

        if (sizeMinVal) {
          sizeMinVal = sizeMinVal.size
          sizeRange.push(Math.floor(sizeMinVal / 25) * 25)
        }

        if (sizeMaxVal) {
          sizeMaxVal = sizeMaxVal.size
          sizeRange.push(Math.ceil(sizeMaxVal / 25) * 25)
        }

        return sizeRange
      }

      if (['apartments', 'townhouses', 'land', 'houses'].includes(pathway) && rootGetters['property/activeLivingOption']) {
        if (getters.activeProperties) {
          let propertyDwellingSizes = []
          getters.activeProperties.forEach(property => {
            if (property.dwelling && property.dwelling.size) {
              propertyDwellingSizes.push(parseInt(property.dwelling.size))
            }
          })

          sizeRange.push(...propertyDwellingSizes)
        }
        sizeRange.push(rootGetters['property/activeLivingOption'].filter.dwellingSizeRange[0], rootGetters['property/activeLivingOption'].filter.dwellingSizeRange[1])

        let min = Math.min(...sizeRange)
        let max = Math.max(...sizeRange)

        min = Math.floor(min / 25) * 25
        max = Math.ceil(max / 25) * 25

        return [min, max]
      }
    }
  }
}
